import {
  API_ERROR,
  RFQ_LIST,
  RFQ_LIST_SUCCESS,
  SELECT_CHANGEVALUE,
  RFQ_ROW_DATA,
  RFQ_ROW_DATA_SUCCESS,
  QUOTATION_ROW_DATA,
  QUOTATION_ROW_DATA_SUCCESS,
  QUOTATION_CHECKED,
  APPROVED_QUANTITY,
  RESET_CELL_UPDATE,
  COMPARE_QUOTATION_ADD,
  COMPARE_QOUTATION_DATA,
  COMPARE_QOUTATION_DATA_SUCCESS,
  COMPARE_QOUTATION_LIST,
  COMPARE_QOUTATION_LIST_SUCCESS,
  PURCHASE_ORDER_DATA,
  PURCHASE_ORDER_LIST,
  PURCHASE_ORDER_LIST_SUCCESS,
  GENERATE_PURCHASE_ORDER,
  GENERATE_PURCHASE_ORDER_RESPONSE,
  SET_PARAMS,
  FILTER_INPUT_CHANGEVALUE,
  FILTER_SELECT_CHANGEVALUE,
  TOGGLE_ITEM_MENU,
  LIST_LAYOUT,
  FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  PO_MODEL_CLOSE,
  PO_MODEL_OPEN,
  PO_VEND_DATA,
  INPUT_CHANGEVALUE,
  PO_SELECT_CHANGEVALUE,
  RESET_SUBLOCATION,
} from "./actionTypes";

export const getRFQList = (data) => {
  return {
    type: RFQ_LIST,
    payload: { data },
  };
};
export const getRFQListSuccessful = (response) => {
  return {
    type: RFQ_LIST_SUCCESS,
    payload: response,
  };
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const getRFQRequestdata = (rfqId) => {
  return {
    type: RFQ_ROW_DATA,
    payload: { rfqId },
  };
};
export const getRFQRequestdataSuccessful = (request) => {
  return {
    type: RFQ_ROW_DATA_SUCCESS,
    payload: request,
  };
};
export const getQuotationsData = (rfqId) => {
  return {
    type: QUOTATION_ROW_DATA,
    payload: { rfqId },
  };
};
export const gettQuotationsDataSuccessful = (request) => {
  return {
    type: QUOTATION_ROW_DATA_SUCCESS,
    payload: request,
  };
};
export const QuotationChecked = (checked, index, vendorId) => {
  return {
    type: QUOTATION_CHECKED,
    payload: { checked, index, vendorId },
  };
};
export const ApprovedQuantity = (ApprovedQuantity, index, vendorId) => {
  return {
    type: APPROVED_QUANTITY,
    payload: { ApprovedQuantity, index, vendorId },
  };
};
export const resetCellUpdate = () => {
  return {
    type: RESET_CELL_UPDATE,
    payload: {},
  };
};
export const CompareQuotationAdd = (data, cqId, history) => {
  return {
    type: COMPARE_QUOTATION_ADD,
    payload: { data, cqId, history },
  };
};
export const getCompareQuotationData = (cqId) => {
  return {
    type: COMPARE_QOUTATION_DATA,
    payload: { cqId },
  };
};
export const CompareQuotationDatasuccessfull = (response) => {
  return {
    type: COMPARE_QOUTATION_DATA_SUCCESS,
    payload: response,
  };
};
export const getCompareQuotationList = (data) => {
  return {
    type: COMPARE_QOUTATION_LIST,
    payload: { data },
  };
};
export const CompareQuotationListSuccessful = (response) => {
  return {
    type: COMPARE_QOUTATION_LIST_SUCCESS,
    payload: response,
  };
};

export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};
export const FilterChangeValue = ({ key, value }) => {
  return {
    type: FILTER_INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const FilterSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: FILTER_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const toggleItemMenu = (id) => {
  return {
    type: TOGGLE_ITEM_MENU,
    payload: id,
  };
};

export const PurchaseOrderData = (data) => {
  return {
    type: PURCHASE_ORDER_DATA,
    payload: data,
  };
};
export const GetPurchaseOrderList = (rfqId) => {
  return {
    type: PURCHASE_ORDER_LIST,
    payload: { rfqId },
  };
};
export const GetPurchaseOrderListSucces = (response) => {
  return {
    type: PURCHASE_ORDER_LIST_SUCCESS,
    payload: response,
  };
};
export const GeneratePurchaseOrder = (data) => {
  return {
    type: GENERATE_PURCHASE_ORDER,
    payload: { data },
  };
};
export const GeneratePurchaseOrderResponse = (data, requestStatus, loading) => {
  return {
    type: GENERATE_PURCHASE_ORDER_RESPONSE,
    payload: { data, requestStatus, loading },
  };
};
export const listlayout = (layout) => {
  return {
    type: LIST_LAYOUT,
    payload: layout,
  };
};
export const FiltersShowRightSidebar = () => {
  return {
    type: FILTERS_SHOW_RIGHT_SIDEBAR,
    payload: null,
  };
};
export const FiltershideRightSidebar = () => ({
  type: FILTERS_HIDE_RIGHT_SIDEBAR,
  payload: null,
});
export const FilterClear = () => {
  return {
    type: CLEAR_FILTER,
    payload: null,
  };
};
export const po_model_open = (CQID) => {
  return {
    type: PO_MODEL_OPEN,
    payload: CQID,
  };
};
export const po_model_close = () => {
  return {
    type: PO_MODEL_CLOSE,
  };
};
export const PurchaseOrderVendData = (index) => {
  return {
    type: PO_VEND_DATA,
    payload: { index },
  };
};
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};

export const ResetSubLocation = () => {
  return {
    type: RESET_SUBLOCATION,
  };
};
export const POSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: PO_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
